const EmptyStar = ({ color = "var(--dark-theme-element)", width = 22, height = 22 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      stroke={color}
      strokeWidth="1.25"
      strokeLinejoin="round"
      strokeLinecap="round">
      <g transform="translate(2,0)">
        <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.743 
                 1.508 8.294L12 18.896l-7.444 4.447 
                 1.508-8.294L0 9.306l8.332-1.151z" />
      </g>
    </svg>
  );
};

export default EmptyStar;